import { breakpoints } from "@/utils/breakpoints/breakpoints";
import { Progress, Typography } from "antd";
import { css, styled } from "styled-components";

const MissionsRenderStyled = styled.div`
    display: flex;
    max-width: 900px;
    width: 100%;
    gap: 32px;
    flex-direction: column;
`

const TitleStyled = styled(Typography)`
    color: ${({ theme }) => theme.colors.text.headings};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Red Hat Display", sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 36px */
    width: 100%;
    text-align: left;

    &.titleBenefit {
        text-align: center;
    }

    &.success {
        color: ${({ theme }) => theme.colors.theme.success};
        width: 100%;
        text-align: center;
    }

    @media (max-width: ${breakpoints.figmaMobile}) {
        text-align: center;
        &.titleBenefit {
            text-align: center;
        }
    }
`

const ObjectivesContainerStyled = styled.div`
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;
    flex-direction: row; 
    @media (max-width: 768px) {
        padding: 0px 12px;
        flex-direction: column;
        align-items: center;
    }
`

const DividerStyled = styled.div`
    flex: 1;
    width: 1px;
    max-width: 1px;
    min-height: 100%;
    align-self: stretch;
    border-top: none;
    border-left: 1px solid ${({ theme }) => theme.colors.text.muted};
    @media (max-width: ${breakpoints.md}) {
        width: 100%;
        max-width: 100%;
        height: 1px;
        min-height: 1px;
        border-left: none;
        border-top: 1px solid ${({ theme }) => theme.colors.text.muted};
    }
`;

const ObjectiveItemLeftStyled = styled.div`
    display: flex;
    max-width: 320px;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    flex: 1 0 0;
`

const ObjectiveItemRightStyled = styled.div`
    display: flex;
    width: 100%;
    max-width: 515px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 32px;
    flex: 1 0 0;
    align-self: stretch;
    margin: 0 auto;
`;

const ObjectiveItemRightBodyStyled = styled(ObjectiveItemRightStyled)<{ $isConnectUser: boolean }>`
    ${({ $isConnectUser }) => {
        return !$isConnectUser &&css`
            mix-blend-mode: luminosity;
            opacity: 0.5;
            pointer-events: none;
            cursor: not-allowed;
            user-select: none;
        `
    }}
`;

const TextCountDownStyled = styled(Typography)`
    color: ${({ theme }) => theme.colors.text.paragraphs};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    margin: 0 auto;
    display: flex;
    padding: var(--Sizes---size-xs, 4px) 0px;
    align-items: center;
    gap: var(--Sizes---size-m, 12px);
    box-sizing: border-box;
`

const ProgressStyled = styled(Progress)`
    &.ant-progress-line {
        .ant-progress-inner {
        background-color: ${({ theme }) => theme.colors.text.muted} !important; /* Color de la barra no completada */
        }
    }
`;




export {
    MissionsRenderStyled,
    TitleStyled,
    ObjectivesContainerStyled,
    ObjectiveItemLeftStyled,
    ObjectiveItemRightStyled,
    TextCountDownStyled,
    ProgressStyled,
    DividerStyled,
    ObjectiveItemRightBodyStyled
}